import { useEffect, useRef } from "react";
import $ from "jquery";
const TableForm = ({ onSubmit, columnData, isSearchDisabled = false, formOnChange = () => { } }) => {
	const jurisdictionRef = useRef();
	const taxonomyRef = useRef();
	const keywordRef = useRef();
	const form = useRef();


	const dropdownColumnData = Object.entries(columnData).map(([key, name], i)=>{
		return{
				name: name,
				value: key,
				active: true
			}
	});

	useEffect(() => {
		if (taxonomyRef.current && jurisdictionRef.current) {
			initROCountryMultiLayer(jurisdictionRef.current).then((dd) => {
				jurisdictionRef.current.addEventListener("itemClick", (e) => {
					formOnChange(e, __.PARSE_FORM_IN_ROVIEWER_FASHION(form.current));
				})
			})
			initROCategoryMultiLayer(taxonomyRef.current).then((dd) => {
				taxonomyRef.current.addEventListener("itemClick", (e) => {
					formOnChange(e, __.PARSE_FORM_IN_ROVIEWER_FASHION(form.current));
				})
			})

			const keywordDropdown = new MultiLayerDropdown(keywordRef.current, {
				searchPlaceholder: "Column",
				levels: ["Columns"],
				keys: ["keyword_column"]
			})

			keywordRef.current.addEventListener("itemClick", (e) => {
				formOnChange(e, __.PARSE_FORM_IN_ROVIEWER_FASHION(form.current));
			})

			keywordDropdown.initializeData(dropdownColumnData)

			keywordDropdown.selectItems({
                keyword_column: [""]
            })
		}
	}, []); // Empty dependency array to run only on mount

	return (
		<form
			ref={form}
			className="control-center [&>button]:btn [&>button]:btn-icon-wide"
			onSubmit={(e) => {
	 			e.preventDefault();
				onSubmit(e, __.PARSE_FORM_IN_ROVIEWER_FASHION(form.current));
			}}
			onChange={(e) => {
				formOnChange(e, __.PARSE_FORM_IN_ROVIEWER_FASHION(form.current));
			}}
		> 
			<div className="w-full" ref={jurisdictionRef}></div>
			<div className="w-full" data-disable-children-on-parent-select="true" ref={taxonomyRef}></div>

			<div className="flex items-center min-w-[200px] h-[35px] border-normal rounded-primary w-[calc(100%+200px)]">
				<div className="min-w-[120px] [&>.multi-layer-dropdown-main-wrapper>.multi-layer-dropdown-input]:border-y-0 [&>.multi-layer-dropdown-main-wrapper>.multi-layer-dropdown-input]:border-l-0 [&>.multi-layer-dropdown-main-wrapper>.multi-layer-dropdown-input>input]:w-full" data-multi-select="false" ref={keywordRef}></div>

				<input
					placeholder="Keyword"
					type="text"
					name="keyword"
					className="input-field border-0"
					data-fk-dt-highlight-target="tbody td:not(:first-child)"
				/>
			</div>
			<input
				placeholder="No"
				type="text"
				name="number"
				className="input-field max-w-[150px]"
				data-fk-dt-highlight-target="tbody td:first-child"
			/>
			<button type="submit" disabled={isSearchDisabled}>
				<span className="material-symbols-rounded">search</span>
			</button>
			<button type="reset">
				<span className="material-symbols-rounded">cached</span>
			</button>
		</form>
	);
};

export default TableForm;
